import { array, func, object } from 'prop-types';
import React, { Fragment, useCallback, useEffect, useState } from 'react';

const checkboxFilters = ( { options, enabledOptions, onChange, selectedDemographic } ) => {

    const [ showMenu, setShowMenu ] = useState( false );
    const [ selected, setSelected ] = useState( [] );
    const [ localDisabledCategories, setLocalDisabledCategories ] = useState( [] );
    const [ outsideComponent, setOutsideComponent ] = useState( false );

    const filteredOptions = options.filter( o => o[ 'label' ] !== 'All Respondents' );

    const handleMouseEnter = useCallback( () => setOutsideComponent( false ), [ outsideComponent ] );
    const handleMouseLeave = useCallback( () => setOutsideComponent( true ), [ outsideComponent ] );

    useEffect( () => {

        const handleDocumentClick = () => {

            if ( outsideComponent ) {

                setShowMenu( false );

            }

        };

        window.addEventListener( 'click', handleDocumentClick );

        // Unmounting
        return ( _ ) => {

            window.removeEventListener( 'click', handleDocumentClick );

        };

    }, [ outsideComponent ] );

    useEffect( () => {

        if ( selectedDemographic ) {

            setLocalDisabledCategories( old => old.filter( o => o !== selectedDemographic[ 'value' ] ) );
            setSelected( old => old.filter( o => o[ 'category' ] !== selectedDemographic[ 'value' ] ) );

        }

    }, [ selectedDemographic ] );

    useEffect( () => {

        onChange( selected );

    }, [ selected, localDisabledCategories ] );

    const onButtonClicked = () => {

        setShowMenu( old => !old );

    };

    const allSubOptionsDisabled = ( category ) => {

        if ( ( selectedDemographic && selectedDemographic[ 'value' ] === category ) || localDisabledCategories.length === 2 || localDisabledCategories.includes( category ) || !( category in enabledOptions ) || !enabledOptions[ category ] || enabledOptions[ category ].length === 0 ) {

            return true;

        }

        return false;

    };

    const isSubOptionDisabled = ( category, subOption ) => {

        if ( ( selectedDemographic && selectedDemographic[ 'value' ] === category ) || !( category in enabledOptions ) || !enabledOptions[ category ]
          || enabledOptions[ category ].length === 0 || !enabledOptions[ category ].includes( subOption ) ) {

            return true;

        }

        return false;

    };

    const isChecked = ( category, subOption ) => {

        if ( isSubOptionDisabled( category, subOption ) ) return false;
        const found = selected.find( s => s[ 'category' ] === category && s[ 'subOption' ] === subOption );

        return found !== null && found !== undefined;

    };

    const handleCheckboxChange = ( category, subOption ) => {

        if ( isChecked( category, subOption ) ) {

            setLocalDisabledCategories( old => old.filter( o => o !== category ) );
            setSelected( old => old.filter( o => o[ 'category' ] !== category && o[ 'subOption' ] !== subOption ) );

        }
        else {

            setLocalDisabledCategories( old => [ ...old, category ] );
            setSelected( old => [ ...old, { category, subOption } ] );

        }

    };

    const handleClickedClear = () => {

        setSelected( [] );
        setLocalDisabledCategories( [] );

    };

    return (
        <div onMouseEnter={ handleMouseEnter } onMouseLeave={ handleMouseLeave } className="checkbox-filters">

            <div className="checkbox-filters-overlay"></div>
            <a className="checkbox-filters-trigger" onClick={ onButtonClicked }><span>Filter</span></a>

            {
                showMenu
                    ? (
                        <div className="checkbox-filters-dropdown">

                            <div className="filter-heading">
                                <h3>
                                    { selected.length > 0 ? ( `${ selected.length } of 2 filters selected.` ) : ( 'Select up to 2 filters.' ) }
                                </h3>
                                { selected.length > 0 && <button type="button" onClick={ handleClickedClear }>Clear</button> }
                            </div>

                            { filteredOptions.map( ( o, idx ) => {

                                return (
                                    <Fragment key={ o[ 'label' ] + idx }>
                                        <h4 className={ allSubOptionsDisabled( o[ 'label' ] ) ? 'disabled-checkbox-group' : '' }>{ o[ 'label' ] }</h4>

                                        { o[ 'options' ].map( ( oo, oIdx ) => {

                                            return (
                                                <label
                                                    htmlFor={ `chkbx-${ o[ 'label' ] }-${ oo[ 'label' ] }` }
                                                    key={ oo[ 'label' ] + oIdx }
                                                    disabled={ !isChecked( o[ 'label' ], oo[ 'label' ] ) && (
                                                        allSubOptionsDisabled( o[ 'label' ] ) || isSubOptionDisabled( o[ 'label' ], oo[ 'label' ] )
                                                    ) }
                                                >
                                                    <input type="checkbox" id={ `chkbx-${ o[ 'label' ] }-${ oo[ 'label' ] }` } onChange={ () => handleCheckboxChange( o[ 'label' ], oo[ 'label' ] ) } checked={ isChecked( o[ 'label' ], oo[ 'label' ] ) } readOnly={ true } />
                                                    { oo[ 'label' ] }
                                                </label>
                                            );

                                        } ) }
                                    </Fragment>
                                );

                            } ) }
                        </div>
                    )
                    : null
            }
        </div>
    );

};

checkboxFilters.propTypes = {
    options: array,
    onChange: func,
    enabledOptions: object,
    selectedDemographic: object,
};

export default checkboxFilters;
